export default "__VITE_ASSET__bUGyk1Fr__"